import { render, staticRenderFns } from "./dg-nav.vue?vue&type=template&id=1b32edfc&scoped=true"
import script from "./dg-nav.vue?vue&type=script&lang=js"
export * from "./dg-nav.vue?vue&type=script&lang=js"
import style0 from "./dg-nav.vue?vue&type=style&index=0&id=1b32edfc&prod&scoped=true&lang=less"
import style1 from "./dg-nav.vue?vue&type=style&index=1&id=1b32edfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32edfc",
  null
  
)

export default component.exports